import { call, put } from "redux-saga/effects";
import {
  addSupplier,
  editSupplier,
  deleteSupplier,
  getSuppliers,
} from "../../app/components/Ancillary/SupplierManagement/helper/supplierManagementHelper.js";
import {
  addSupplierSuccessAction,
  editSupplierSuccessAction,
  deleteSupplierSuccessAction,
  getSuppliersSuccessAction,
} from "./actions";

export function* addSupplierSaga(payload) {
  try {
    const response = yield call(addSupplier, payload.supplierData);
    yield put(addSupplierSuccessAction(response.data));
  } catch (err) {}
}

export function* editSupplierSaga(payload) {
  try {
    const response = yield call(editSupplier, payload.supplierData);
    yield put(editSupplierSuccessAction(response.data));
  } catch (err) {}
}

export function* deleteSupplierSaga(payload) {
  try {
    const response = yield call(deleteSupplier, payload.supplierData);
    yield put(deleteSupplierSuccessAction(response.data));
  } catch (err) {}
}

export function* getSuppliersSaga(payload) {
  try {
    const response = yield call(getSuppliers, payload.storeId);
    yield put(getSuppliersSuccessAction(response.data));
  } catch (err) {}
}